import deleteConfirmationModal from './deleteConfirmationModal.html';

/* @ngInject */
export default function ($scope, AuthService, Quoting, DataTablesService, $uibModal, toastr, LayoutService, $state, PreferencesService) {
	AuthService.redirectIfUnauthorized('view-quoting', 'splash.home');

	LayoutService.setTitle('Quotes');

	const updateButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

	const newButton = LayoutService.getPageHeader()
	                               .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-plus"></i> New Quote</button>');

	const servicesButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-upload"></i> Services</button>');

	const publicHolidaysButton = LayoutService.getPageHeader()
	                                  .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-upload"></i> Public Holidays</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.quoting.root',
			             displayName: 'Quotes',
		             },
	             ]);

	$scope.loading = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.apiURL = process.env.API_ENDPOINT;
	$scope.token  = AuthService.getToken();

	$scope.dtOptions = DataTablesService.configure({
		title: 'Quotes',
	}, {
		order: [
			[
				0,
				'desc',
			],
		],
	}).options;

	$scope.deleteQuote = (quoteID) => {
		$scope.selectedForDeletion = quoteID;

		const modalInstance = $uibModal.open({
			animation:                  true,
			template:                   deleteConfirmationModal,
			scope:                      $scope,
			size:                       'sm',
			controller: /* @ngInject */ ($scope, $uibModalInstance) => {
				$scope.cancel = () => {
					$uibModalInstance.close();
				};

				$scope.confirm = () => {
					Quoting.deleteQuote($scope.selectedForDeletion)
					       .then((data) => {
						       toastr.clear();
						       toastr.success('Quote was successfully deleted.', 'Deleted');
						       $uibModalInstance.close();
						       $scope.refresh();
					       })
					       .catch((error) => {
						       toastr.clear();
						       toastr.error('There was an error while deleting the quote, please try again.', 'Error');
						       $uibModalInstance.close();
					       });
				};
			},
		});
	};

	$scope.refresh = () => {
		$scope.loading = true;

		Quoting
			.getList({
				include: 'enquiry',
			})
			.then((data) => {
				$scope.data = data;

				$scope.loading = false;
			});
	};

	LayoutService.getPageHeader()
	             .onClicked(updateButton, $scope.refresh);

	LayoutService.getPageHeader()
	             .onClicked(newButton, () => {
		             $state.go('staff.quoting.new');
	             });

	LayoutService.getPageHeader()
	             .onClicked(servicesButton, () => {
		             $state.go('staff.quoting.services');
	             });

	LayoutService.getPageHeader()
	             .onClicked(publicHolidaysButton, () => {
		             $state.go('staff.quoting.publicHolidays');
	             });

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/quoting/root/controller.js